// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 海螺音乐生成节点样式 */
.HailuoMusicNode-container {
  position: relative;
  background: white;
  border: 2px solid #ddd;
  border-radius: 12px;
  padding: 16px;
  min-width: 280px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.HailuoMusicNode-title {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: monospace;
}

.HailuoMusicNode-wrapper {
  width: 280px;
}

.HailuoMusicNode-field {
  margin-bottom: 12px;
}

.HailuoMusicNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

/* 标签与提示组合 */
.HailuoMusicNode-label-with-hint {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.HailuoMusicNode-label-with-hint .HailuoMusicNode-label {
  margin-bottom: 0;
}

.HailuoMusicNode-label-hint {
  font-size: 10px;
  color: #999;
  font-weight: 400;
}

/* 连接文本显示 */
.HailuoMusicNode-connected-text {
  padding: 8px 12px;
  background: #e8f5e9;
  border: 1px solid #81c784;
  border-radius: 6px;
  font-size: 12px;
  color: #2e7d32;
  line-height: 1.5;
  word-break: break-word;
}

/* 未连接占位符 */
.HailuoMusicNode-placeholder {
  padding: 8px 12px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  font-size: 12px;
  color: #856404;
  text-align: center;
}

/* 模型显示 */
.HailuoMusicNode-model-display {
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 13px;
  color: #495057;
  font-family: monospace;
}

/* 下拉选择器 */
.HailuoMusicNode-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.HailuoMusicNode-select:focus {
  outline: none;
  border-color: #667eea;
}

.HailuoMusicNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 高级设置 */
.HailuoMusicNode-advanced-toggle {
  margin-bottom: 12px;
}

.HailuoMusicNode-toggle-button {
  width: 100%;
  padding: 8px 12px;
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.HailuoMusicNode-toggle-button:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.HailuoMusicNode-toggle-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.HailuoMusicNode-advanced {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #e9ecef;
}

/* 连接说明 */
.HailuoMusicNode-connection-guide {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #e3f2fd;
  border-radius: 6px;
  border-left: 3px solid #2196f3;
}

.HailuoMusicNode-guide-title {
  font-size: 11px;
  font-weight: 600;
  color: #1565c0;
  margin-bottom: 6px;
}

.HailuoMusicNode-guide-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 11px;
  color: #1976d2;
}

.HailuoMusicNode-guide-item:last-child {
  margin-bottom: 0;
}

.HailuoMusicNode-guide-icon {
  flex-shrink: 0;
  font-size: 12px;
}

.HailuoMusicNode-guide-text {
  line-height: 1.4;
}

/* 生成按钮 */
.HailuoMusicNode-generate {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

.HailuoMusicNode-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.HailuoMusicNode-generate:active {
  transform: translateY(0);
}

.HailuoMusicNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* 错误提示 */
.HailuoMusicNode-error {
  padding: 10px 12px;
  background-color: #fee;
  color: #c33;
  border-radius: 6px;
  font-size: 12px;
  margin-top: 8px;
  border-left: 3px solid #c33;
}

/* Handle 样式 */
.HailuoMusicNode-handle {
  width: 12px;
  height: 12px;
  background: #667eea;
  border: 2px solid white;
  transition: all 0.2s ease;
}

.HailuoMusicNode-handle:hover {
  width: 16px;
  height: 16px;
  border-width: 3px;
}

/* Handle 标签 */
.HailuoMusicNode-handle-label {
  position: absolute;
  left: -100px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

.HailuoMusicNode-handle:hover .HailuoMusicNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);
}

.HailuoMusicNode-handle:hover .HailuoMusicNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #ec4899;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(236, 72, 153, 0.2));
}

.HailuoMusicNode-handle-prompt .HailuoMusicNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.HailuoMusicNode-handle-prompt:hover .HailuoMusicNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.HailuoMusicNode-handle-prompt:hover .HailuoMusicNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

/* 节点选中时始终展示接入说明，并强化可见性 */
.react-flow__node.selected .HailuoMusicNode-handle .HailuoMusicNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);
}

.react-flow__node.selected .HailuoMusicNode-handle-prompt .HailuoMusicNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .HailuoMusicNode-handle {
  box-shadow: 0 0 0 4px rgba(236, 72, 153, 0.25);
}

/* 标签出现动画 */
@keyframes HailuoMusicNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.HailuoMusicNode-handle:hover .HailuoMusicNode-handle-label,
.react-flow__node.selected .HailuoMusicNode-handle .HailuoMusicNode-handle-label {
  animation: HailuoMusicNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 可点击的 Handle 标签 */
.HailuoMusicNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.HailuoMusicNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.45);
}

.HailuoMusicNode-handle-prompt .HailuoMusicNode-handle-label-clickable:hover {
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);
}

/* 可点击标签的按下效果 */
.HailuoMusicNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.HailuoMusicNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.HailuoMusicNode-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 复制按钮 */
.HailuoMusicNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.HailuoMusicNode-container:hover .HailuoMusicNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.HailuoMusicNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/HailuoMusicNode.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,wEAAwE;AAC1E;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":["/* 海螺音乐生成节点样式 */\n.HailuoMusicNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #ddd;\n  border-radius: 12px;\n  padding: 16px;\n  min-width: 280px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.HailuoMusicNode-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-family: monospace;\n}\n\n.HailuoMusicNode-wrapper {\n  width: 280px;\n}\n\n.HailuoMusicNode-field {\n  margin-bottom: 12px;\n}\n\n.HailuoMusicNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n/* 标签与提示组合 */\n.HailuoMusicNode-label-with-hint {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.HailuoMusicNode-label-with-hint .HailuoMusicNode-label {\n  margin-bottom: 0;\n}\n\n.HailuoMusicNode-label-hint {\n  font-size: 10px;\n  color: #999;\n  font-weight: 400;\n}\n\n/* 连接文本显示 */\n.HailuoMusicNode-connected-text {\n  padding: 8px 12px;\n  background: #e8f5e9;\n  border: 1px solid #81c784;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #2e7d32;\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n/* 未连接占位符 */\n.HailuoMusicNode-placeholder {\n  padding: 8px 12px;\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #856404;\n  text-align: center;\n}\n\n/* 模型显示 */\n.HailuoMusicNode-model-display {\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #495057;\n  font-family: monospace;\n}\n\n/* 下拉选择器 */\n.HailuoMusicNode-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.HailuoMusicNode-select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.HailuoMusicNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* 高级设置 */\n.HailuoMusicNode-advanced-toggle {\n  margin-bottom: 12px;\n}\n\n.HailuoMusicNode-toggle-button {\n  width: 100%;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.HailuoMusicNode-toggle-button:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.HailuoMusicNode-toggle-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.HailuoMusicNode-advanced {\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  border: 1px solid #e9ecef;\n}\n\n/* 连接说明 */\n.HailuoMusicNode-connection-guide {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  background: #e3f2fd;\n  border-radius: 6px;\n  border-left: 3px solid #2196f3;\n}\n\n.HailuoMusicNode-guide-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #1565c0;\n  margin-bottom: 6px;\n}\n\n.HailuoMusicNode-guide-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n  font-size: 11px;\n  color: #1976d2;\n}\n\n.HailuoMusicNode-guide-item:last-child {\n  margin-bottom: 0;\n}\n\n.HailuoMusicNode-guide-icon {\n  flex-shrink: 0;\n  font-size: 12px;\n}\n\n.HailuoMusicNode-guide-text {\n  line-height: 1.4;\n}\n\n/* 生成按钮 */\n.HailuoMusicNode-generate {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 8px;\n}\n\n.HailuoMusicNode-generate:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.HailuoMusicNode-generate:active {\n  transform: translateY(0);\n}\n\n.HailuoMusicNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* 错误提示 */\n.HailuoMusicNode-error {\n  padding: 10px 12px;\n  background-color: #fee;\n  color: #c33;\n  border-radius: 6px;\n  font-size: 12px;\n  margin-top: 8px;\n  border-left: 3px solid #c33;\n}\n\n/* Handle 样式 */\n.HailuoMusicNode-handle {\n  width: 12px;\n  height: 12px;\n  background: #667eea;\n  border: 2px solid white;\n  transition: all 0.2s ease;\n}\n\n.HailuoMusicNode-handle:hover {\n  width: 16px;\n  height: 16px;\n  border-width: 3px;\n}\n\n/* Handle 标签 */\n.HailuoMusicNode-handle-label {\n  position: absolute;\n  left: -100px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(236, 72, 153, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n.HailuoMusicNode-handle:hover .HailuoMusicNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);\n}\n\n.HailuoMusicNode-handle:hover .HailuoMusicNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #ec4899;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(236, 72, 153, 0.2));\n}\n\n.HailuoMusicNode-handle-prompt .HailuoMusicNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.HailuoMusicNode-handle-prompt:hover .HailuoMusicNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.HailuoMusicNode-handle-prompt:hover .HailuoMusicNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n/* 节点选中时始终展示接入说明，并强化可见性 */\n.react-flow__node.selected .HailuoMusicNode-handle .HailuoMusicNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);\n}\n\n.react-flow__node.selected .HailuoMusicNode-handle-prompt .HailuoMusicNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .HailuoMusicNode-handle {\n  box-shadow: 0 0 0 4px rgba(236, 72, 153, 0.25);\n}\n\n/* 标签出现动画 */\n@keyframes HailuoMusicNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.HailuoMusicNode-handle:hover .HailuoMusicNode-handle-label,\n.react-flow__node.selected .HailuoMusicNode-handle .HailuoMusicNode-handle-label {\n  animation: HailuoMusicNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 可点击的 Handle 标签 */\n.HailuoMusicNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.HailuoMusicNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.45);\n}\n\n.HailuoMusicNode-handle-prompt .HailuoMusicNode-handle-label-clickable:hover {\n  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);\n}\n\n/* 可点击标签的按下效果 */\n.HailuoMusicNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.HailuoMusicNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.HailuoMusicNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 复制按钮 */\n.HailuoMusicNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.HailuoMusicNode-container:hover .HailuoMusicNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.HailuoMusicNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
